import reducer from './reducer'

import * as servicingSelectors from './selectors'
import * as servicingThunks from './thunks'

export { servicingSelectors, servicingThunks }
export { isServicingMutation, SERVICING_SOURCE_NAMESPACES } from './mutations'
export type { ServicingState } from './reducer'
export type { ServicingFeedQuery, ServicingFeedWindow } from './types'

export default reducer
